import styled from "styled-components";

export const Container = styled.header`
    display: flex;
    flex-direction: column;

    width: 100%;
    max-width: 100vw;
`;

export const Topbar = styled.div`
    width: 100%;
    height: 30px;
    background: #94E8E8;
    text-align: right;
    vertical-align: middle;

    padding: 5px 20px;
    font-size: 10px;
    line-height: 20px;
`;

export const Logo = styled.div`
    width: 100%;
    border-bottom: 5px solid #363c42;
    padding: 20px;

    .logo {
        float: left;

        img {
            width: 170px;
            margin: 6px 0px 0px 1px
        }
    }
    
    .title {
        float: left;
        margin-left: 40px;
        
        p {
            margin-bottom: 0px;
            line-height: 53px; 
            font-size: 35px;
        }
    }
`;
